import { IPageTabNavLink } from "../interfaces-and-types";

export const paymentmethodsLink: IPageTabNavLink[] = [
    {
        name: 'Payment Methods',
        route: '',
    },
]